var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset39(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 160.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin-dark {\n        fill: #d1af86;\n      }\n      .skin {\n        fill: #dcba8b;\n      }\n      .skin-light {\n        fill: #f4cd98;\n      }\n      .skin-darker {\n        fill: #a37b50;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad_copy",
    "data-name": "sad copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "skin-dark",
    d: "M79.52,120.54H52.1c-11.74,0-19.89-12.33-18.34-26.28l9.13-82.63C43.61,5,50.06,0,57.32,0h17C81.56,0,88,5,88.73,11.63l9.13,82.63C99.41,108.21,91.26,120.54,79.52,120.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M107.44,103.34c19.71,24.58,4.26,60.87-50.66,56.66-34.1-2.61-54.14-32.08-34.43-56.66C32.58,90.58,50,84,64.9,84S97.21,90.58,107.44,103.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin-light",
    d: "M29.3,105.3A26.57,26.57,0,0,1,32.69,102a40.5,40.5,0,0,1,3.81-2.84,51.12,51.12,0,0,1,8.4-4.46,52.58,52.58,0,0,1,18.78-4c.81,0,1.62,0,2.43,0s1.63,0,2.44.11c1.62.12,3.24.34,4.84.6.8.15,1.59.34,2.39.51a21.56,21.56,0,0,1,2.36.62c.77.24,1.56.44,2.32.72l2.26.88a41.28,41.28,0,0,1,8.41,4.67,35,35,0,0,1,6.92,6.5,151,151,0,0,0-17.34-4.39c-2.81-.49-5.62-.81-8.41-1-1.41-.07-2.8-.2-4.21-.19-.7,0-1.4-.05-2.1,0s-1.4,0-2.1,0a113.79,113.79,0,0,0-17,1.77C41.17,102.45,35.42,103.79,29.3,105.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin-darker",
    cx: 68.48,
    cy: 54.61,
    rx: 2.65,
    ry: 4.51,
    transform: "translate(7.79 117.76) rotate(-84.71)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin-darker",
    cx: 54.03,
    cy: 64.44,
    rx: 5.27,
    ry: 3.1,
    transform: "matrix(0.96, -0.29, 0.29, 0.96, -16.33, 18.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin-darker",
    cx: 72.87,
    cy: 70.77,
    rx: 7.69,
    ry: 4.48,
    transform: "translate(-11.91 14.81) rotate(-10.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 18.29,
    cy: 139.5,
    rx: 18.29,
    ry: 17.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 109.71,
    cy: 139.5,
    rx: 18.29,
    ry: 17.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset39);
export default __webpack_public_path__ + "static/media/Asset 39.688c944b.svg";
export { ForwardRef as ReactComponent };